module.exports = __webpack_public_path__ + "img/flake.4d8486a8.svg";